import { Link } from 'react-router-dom';
import { hotTopics } from '@/mocks/gossip';

export default function HotRanking() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-10">
          <div className="lg:w-1/2">
            <p className="text-xs font-semibold text-accent-600 uppercase tracking-widest mb-2 font-heading">
              Trending Now
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-6">
              热门大瓜排行
            </h2>

            <Link
              to={`/article/${hotTopics[0].slug}`}
              className="block group cursor-pointer"
            >
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
                <img
                  src={hotTopics[0].imageUrl}
                  alt={hotTopics[0].title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <span className="px-2.5 py-1 bg-background-50/20 backdrop-blur-md text-background-50 text-xs font-semibold rounded-full">
                    TOP 1
                  </span>
                  <span className="px-2.5 py-1 bg-accent-500/90 text-background-50 text-xs font-semibold rounded-full flex items-center gap-1">
                    <i className="ri-fire-line text-[10px]"></i>
                    爆
                  </span>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <h3 className="text-lg md:text-xl font-bold text-background-50 leading-snug mb-2">
                    {hotTopics[0].title}
                  </h3>
                  <div className="flex items-center gap-4 text-xs text-background-50/70">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {(hotTopics[0].views / 10000).toFixed(1)}万 阅读
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {(hotTopics[0].comments / 10000).toFixed(1)}万 评论
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="lg:w-1/2">
            <div className="flex items-center gap-2 mb-4 md:mb-6 flex-wrap">
              <span className="px-3 py-1.5 border border-background-300 text-xs font-medium text-foreground-700 rounded-full whitespace-nowrap">
                今日热门
              </span>
              <span className="px-3 py-1.5 text-xs font-medium text-foreground-500 hover:text-foreground-700 rounded-full transition-colors cursor-pointer whitespace-nowrap">
                本周
              </span>
              <span className="px-3 py-1.5 text-xs font-medium text-foreground-500 hover:text-foreground-700 rounded-full transition-colors cursor-pointer whitespace-nowrap">
                本月
              </span>
            </div>

            <div className="space-y-4">
              {hotTopics.slice(1).map((topic) => (
                <Link
                  key={topic.id}
                  to={`/article/${topic.slug}`}
                  className="flex gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group"
                >
                  <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-lg overflow-hidden">
                    <img
                      src={topic.imageUrl}
                      alt={topic.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0 flex flex-col justify-between">
                    <div>
                      <div className="flex items-center gap-2 mb-1">
                        <span className="w-5 h-5 flex items-center justify-center rounded bg-foreground-900 text-background-50 text-[10px] font-bold flex-shrink-0">
                          {topic.rank}
                        </span>
                        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors line-clamp-2 leading-snug">
                          {topic.title}
                        </h3>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 text-xs text-foreground-500 mt-2">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {(topic.views / 10000).toFixed(1)}万
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line"></i>
                        {(topic.comments / 10000).toFixed(1)}万
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}